import { ResourcesInterface } from "./interfaces";
import Api from "../services/Api.ts";


export default class RecordSound {
  private mediaRecorder: MediaRecorder | null = null;
  private session: number = 0;
  private startTime = new Date();

  constructor() {
    console.log('Initialized RecordSound');
  }

  start = (resources: ResourcesInterface, api: Api) => {
    // Force sending to localhost or backoffice backend, since files are stored locally
    const apiUrl = api.baseUrl.startsWith('https') ? 'https://backoffice.zebrain.se/api/' : api.baseUrl
    if (resources.localStream) {
      // We need to merge all audio streams into one destination
      const context = new AudioContext();

      const sourceLocal = context.createMediaStreamSource(resources.localStream);
      const gainLocal = context.createGain();
      gainLocal.gain.value = 0.7;

      const destination = context.createMediaStreamDestination();
      sourceLocal.connect(gainLocal).connect(destination);

      // Add all partner video streams
      for (const partner of resources.partners) {
        if (partner.videoStream) {
          const sourceP = context.createMediaStreamSource(partner.videoStream);
          const gainP = context.createGain();
          gainP.gain.value = 0.7;
          sourceP.connect(gainLocal).connect(destination);
        }
      }

      const streams = new MediaStream();
      for (const track of destination.stream.getAudioTracks()) {
        console.log('Added track');
        console.log(track);
        streams.addTrack(track);
      }
      // for (const partner of resources.partners) {
      //   if (partner.audioTrack) {
      //     console.log('Added partner track');
      //     console.log(partner.audioTrack);
      //     streams.addTrack(partner.audioTrack);
      //   }
      // }

      this.mediaRecorder = new MediaRecorder(streams);
      this.startTime = new Date();
      this.mediaRecorder.start(2000);
      this.mediaRecorder.ondataavailable = (e) => {
        const formData = new FormData();
        formData.append('audio', e.data);
        formData.append('session', '' + this.session);
        const url = apiUrl + 'client/record_stream/meeting_' + resources.meetingKey
        fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + api.apiToken,
          },
          body: formData
        }).then(response => {
          console.log(response);
        })
      }

      this.mediaRecorder.onstop = (e) => {
        this.session++;
        console.log('Stopped record');
        let now = new Date();
        let duration = now.getTime() - this.startTime.getTime();
        const url = apiUrl + 'client/record_stop/meeting_' + resources.meetingKey + "?duration=" + duration.toFixed(0);
        fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + api.apiToken,
          },
        }).then(response => {
          console.log(response);
        });
      }
    } else {
      console.log("Missing resources");
    }
  }

  stop = () => {
    if (this.mediaRecorder) {

      this.mediaRecorder.stop();
    } else {
      console.log("Missing mediaRecorder");
    }
  }

}